import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FindingType_Textual } from '@app/advisor-shared';
import { ComponentSync, LL_V_L, TS_CollapsableContainerV2 } from '@nu-art/thunderstorm-frontend';
import { asArray, sortArray } from '@nu-art/ts-common';
import './Component_HomeHPIV2.scss';
import { AdvisorConfigKeyFE_HomePanel, AdvisorConfigKeyFE_HPIVarID, ModuleFE_AdvisorState, ModuleFE_EMInterface, ModuleFE_RuntimeFinding } from '@app/advisor-frontend';
import { ModuleFE_AdvisorAnalytics } from '../../../../../_analytics/consts.js';
import { Component_WizardIcon } from '../../../advisor-wizard/Component_WizardIcon/Component_WizardIcon.js';
import { Component_HPI } from '../../../hpi/Component_HPI/Component_HPI.js';
export class Component_HomeHPIV2 extends ComponentSync {
    //######################### Life Cycle #########################
    __onPractitionerConfigUpdated = () => {
        this.setState({ collapsed: ModuleFE_AdvisorState.getStateProperty.collapsing.homePanel.hpi() ?? true });
    };
    __onReadOnlyChanged = () => this.forceUpdate();
    __onRuntimeFindingsUpdated = (...params) => {
        //Trigger re-derive if one of the findings was HPI
        const hpiVarId = AdvisorConfigKeyFE_HPIVarID.get();
        const findings = asArray(params[1]);
        if (findings.find(f => f.variableId === hpiVarId))
            this.reDeriveState();
        else
            this.forceUpdate();
    };
    deriveStateFromProps(nextProps, state) {
        state.hpiFinding = this.getHPIFinding();
        state.collapsed ??= ModuleFE_AdvisorState.getStateProperty.collapsing.homePanel.hpi() ?? true;
        state.config ??= AdvisorConfigKeyFE_HomePanel.get()?.sections?.hpi;
        return state;
    }
    //######################### Logic #########################
    getHPIFinding() {
        const variableId = AdvisorConfigKeyFE_HPIVarID.get();
        const findings = ModuleFE_RuntimeFinding.cache.filter(finding => finding.type === FindingType_Textual && finding.variableId === variableId);
        sortArray(findings, f => f.issuedTimestamp, true);
        return findings[0];
    }
    canEditHPI = () => {
        return !ModuleFE_EMInterface.isPostDisposition() && !ModuleFE_EMInterface.isReadonly();
    };
    toggleCollapse = () => {
        const nextCollapse = !this.state.collapsed;
        ModuleFE_AdvisorState.setProperty.collapsing.homePanel.hpi(nextCollapse);
        if (!nextCollapse) { //Report analytics if opened
            ModuleFE_AdvisorAnalytics.trigger.view.view__hpi();
        }
    };
    //######################### Render #########################
    render() {
        return _jsx(TS_CollapsableContainerV2, { className: 'home-hpi-v2', collapsed: this.state.collapsed, onCollapseToggle: this.toggleCollapse, headerRenderer: this.render_HPI_Header, containerRenderer: () => _jsx(Component_HPI, {}), animated: true, forceUpdate: true });
    }
    render_HPI_Header = () => {
        const canEdit = this.canEditHPI();
        return _jsxs(_Fragment, { children: [_jsx(LL_V_L, { className: 'home-hpi-v2__header', children: _jsx("div", { className: 'home-hpi-v2__header-title', children: "Chief Complaint & HPI" }) }), canEdit && _jsx(Component_WizardIcon, { wizardFilter: w => w.config.isHpi })] });
    };
}
//# sourceMappingURL=Component_HomeHPIV2.js.map